import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class GenpdfService {

  constructor() { }

  private descargaPdf = new Subject<any>();
  private filtrosActualizados = new Subject<any>();

  descargaPdf$ = this.descargaPdf.asObservable();
  filtrosActualizados$ = this.filtrosActualizados.asObservable();

  // actualizarFiltros(filtros: any) {
  //   this.filtrosActualizados.next(filtros);
  // }
  descargarPdf(genpdf:any) {
    this.descargaPdf.next(genpdf);
  }
}
